module.exports = __webpack_public_path__ + "img/doses-left-icon.0e228268.png";